import { Button, Drawer } from '@tecsinapse/cortex-react'
import { chatDrawerVariants } from '@web/modules/core'
import React, { useEffect } from 'react'
import { MdOutlineClose } from 'react-icons/md'

type AnchorPosition = 'left' | 'right'

interface ChatDrawerProps {
  headerTitle?: string
  children?: React.ReactNode
  open: boolean
  onClose: () => void
  anchorPosition: AnchorPosition
}

const { containerHeader, containerHeaderTitle, title, buttonClose, buttonIcon, containerChildren } =
  chatDrawerVariants()

const ChatDrawer = ({ children, headerTitle, open, onClose, anchorPosition }: ChatDrawerProps) => {
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'auto'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [open])

  return (
    <Drawer
      open={open}
      onClose={onClose}
      position={anchorPosition}
    >
      <div className={containerHeader()}>
        <div className={containerHeaderTitle()}>
          <p className={title()}>{headerTitle}</p>
        </div>
        <div className={buttonClose()}>
          <Button
            variants={{ size: 'square' }}
            onClick={onClose}
          >
            <div className={buttonIcon()}>
              <MdOutlineClose />
            </div>
          </Button>
        </div>
      </div>

      <div className={containerChildren()}>{children}</div>
    </Drawer>
  )
}

export default ChatDrawer
